module.exports = __webpack_public_path__ + "static/img/fish51.4616172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish51.png
// module id = NnGz
// module chunks = 0